import {
  type DigitalGiftCardsActionTypes,
  SET_CREDIT_CARD_REQUEST_STATUS,
  SET_DIGITAL_GIFT_CARDS_SETTINGS,
  SET_PROCESSED_GIFT_CARD_PAYMENT,
} from "actions/digital_gift_cards";

import type { DigitalGiftCardsReduxState } from "types/digital_gift_cards";
import { RequestStatus } from "types/requests";

const initialState: DigitalGiftCardsReduxState = {
  settingsRequest: { type: RequestStatus.NOT_STARTED },
  orderRequest: { type: RequestStatus.NOT_STARTED },
  afterProcessedPaymentRequest: { type: RequestStatus.NOT_STARTED },
  creditCardRequestStatus: RequestStatus.NOT_STARTED,
};

function digitalGiftCardsReducer(
  state: DigitalGiftCardsReduxState = initialState,
  action: DigitalGiftCardsActionTypes
) {
  switch (action.type) {
    case SET_DIGITAL_GIFT_CARDS_SETTINGS: {
      return {
        ...state,
        settingsRequest: action.settings,
      };
    }

    case SET_PROCESSED_GIFT_CARD_PAYMENT: {
      return {
        ...state,
        afterProcessedPaymentRequest: action.processedGiftCardPayment,
      };
    }

    case SET_CREDIT_CARD_REQUEST_STATUS: {
      return {
        ...state,
        creditCardRequestStatus: action.status,
      };
    }

    default:
      return state;
  }
}

export default digitalGiftCardsReducer;
